import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-right', 'ArrowUpRight', [["path",{"d":"m6.5 17.5 11-11m0 0h-9m9 0v9","key":"svg-0"}]]);